import { render } from "./GuessTheBalance.vue?vue&type=template&id=317e7b72"
import script from "./GuessTheBalance.vue?vue&type=script&lang=js"
export * from "./GuessTheBalance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__